import { withProfiler, ErrorBoundary } from "@sentry/react";
import { withLDProvider } from "launchdarkly-react-client-sdk";

import { AllRoutes } from "./common/Pages/AllRoutes";
import { RotateDevice } from "./common/components/RotateDevice";
import { dynamicConfig } from "./config";
import { UserProvider } from "./common/context/UserContext";
import { isLocalHost } from "./common/utils/isLocalHost";
import { AppVersionProcess } from "./common/components/AppVersionProcess";

const App = () => (
  <ErrorBoundary>
    {process.env.NODE_ENV === "production" && <AppVersionProcess />}
    <UserProvider>
      <AllRoutes />
      <RotateDevice />
    </UserProvider>
  </ErrorBoundary>
);

const AppWithLDProvider = withLDProvider({
  clientSideID: dynamicConfig.features.clientSdkId as string,
})(App);

export default withProfiler(isLocalHost && process.env.NODE_ENV !== "development" ? App : AppWithLDProvider);
